import { render, staticRenderFns } from "./CohortRegistrationPage.vue?vue&type=template&id=4563a93c"
import script from "./CohortRegistrationPage.vue?vue&type=script&lang=js"
export * from "./CohortRegistrationPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports